/* LSL · Haut de page : comportement (sections/lsl-hd.liquid, styles lsl-hd.css).
   1. Barre d'annonces : un message à la fois sur mobile (effet hologramme, minuteur, glisser), étoiles qui se remplissent.
   2. Bandeau Black Month : accélère quand on fait défiler la page, repart en arrière quand on remonte, ralentit au survol.
   3. Header : lumière qui suit la souris, reflet sur le logo, étiquettes des icônes, panier qui s'allume à l'ajout.
   4. Notice : l'icône est rangée dans le header ; un bouton est ajouté dans le pied du tiroir du menu (lsl-nav),
      et la notice est proposée en premier quand on cherche « notice », « mode d'emploi », « recharger »…
   5. Recherche en direct : la loupe du header ouvre la fenêtre (aussi Ctrl K, ⌘K ou /). */
(() => {
  'use strict';
  if (window.__lslHd) return;
  window.__lslHd = true;

  const html = document.documentElement;
  const R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const bot = /bot|crawl|spider|lighthouse|headless/i.test(navigator.userAgent);
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (src, w) => src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '';
  const NOTICE_RE = /notic|mode d.?emploi|manuel|utilis|recharg|allum|batter|bouton|chargeur|reglage|réglage|volume|couleur du sabre|changer (de )?(son|couleur)/i;
  const SV = {
    search: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5L21 21"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h13M13 6l6 6-6 6"/></svg>',
    grid: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/></svg>',
    page: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 3.5h7l4 4V20.5H7z"/><path d="M14 3.5v4h4M9.5 12h6M9.5 15.5h6"/></svg>',
    clock: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="8"/><path d="M12 8v4.5l3 1.5"/></svg>',
    book: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 6.5C10.4 5 8 4.5 4.5 4.5v13c3.5 0 5.9.5 7.5 2 1.6-1.5 4-2 7.5-2v-13C16 4.5 13.6 5 12 6.5z"/><path d="M12 6.5v13"/></svg>'
  };

  /* ================= 1. Barre d'annonces ================= */
  const GLYPHS = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789#%+=<>/';
  function decode(t, delay) {
    if (!t || reduce.matches || bot) return;
    const a = t.parentElement, final = t.textContent;
    const fx = document.createElement('span');
    fx.className = 'lsl-ann__fx'; fx.setAttribute('aria-hidden', 'true');
    fx.style.left = t.offsetLeft + 'px'; fx.style.top = t.offsetTop + 'px'; fx.style.width = t.offsetWidth + 'px';
    fx.style.font = 'inherit';
    a.querySelectorAll('.lsl-ann__fx').forEach(x => x.remove());
    const cs = getComputedStyle(t);
    fx.style.cssText += ';font:' + cs.font + ';letter-spacing:' + cs.letterSpacing + ';text-transform:' + cs.textTransform + ';line-height:' + cs.lineHeight + ';text-align:' + cs.textAlign;
    a.append(fx);
    t.classList.add('is-dec');
    const dur = 560, t0 = performance.now() + (delay || 0);
    const step = now => {
      const p = Math.max(0, Math.min(1, (now - t0) / dur));
      const k = Math.floor(p * final.length * 1.08);
      let out = '';
      for (let i = 0; i < final.length; i++) {
        const c = final[i];
        out += (i < k || c === ' ') ? c : GLYPHS[(Math.random() * GLYPHS.length) | 0];
      }
      fx.textContent = out;
      if (p < 1) requestAnimationFrame(step);
      else { fx.remove(); t.classList.remove('is-dec'); }
    };
    requestAnimationFrame(step);
  }

  function annInit(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const items = [...root.querySelectorAll('.lsl-ann__it')];
    const mqM = matchMedia('(max-width: 899.98px)');
    const speed = (+root.dataset.speed || 6) * 1000;
    root.style.setProperty('--t', speed + 'ms');
    root.classList.add('is-pre');
    setTimeout(() => root.classList.remove('is-pre'), 500);

    let i = 0, timer = 0, t0 = 0, left = speed, paused = false;
    const arm = ms => { clearTimeout(timer); t0 = Date.now(); left = ms; timer = setTimeout(() => show(i + 1), ms); };
    const canRun = () => mqM.matches && !reduce.matches && items.length > 1;
    const restart = () => {
      clearTimeout(timer); root.classList.remove('is-run'); void root.offsetWidth;
      if (!canRun()) return;
      root.classList.add('is-run'); left = speed;
      if (!paused) arm(speed);
    };
    const show = n => {
      if (items.length < 2) return;
      n = (n + items.length) % items.length;
      if (n === i) return;
      const old = items[i];
      old.classList.remove('is-on'); old.classList.add('is-out');
      setTimeout(() => old.classList.remove('is-out'), 460);
      i = n; items[i].classList.add('is-on');
      decode(items[i].querySelector('.lsl-ann__t'), 60);
      restart();
    };
    const pause = () => { if (paused) return; paused = true; clearTimeout(timer); left = Math.max(0, left - (Date.now() - t0)); root.classList.add('is-paused'); };
    const resume = () => { if (!paused) return; paused = false; root.classList.remove('is-paused'); if (root.classList.contains('is-run')) arm(Math.max(300, left)); };

    root.addEventListener('click', e => { const b = e.target.closest('[data-ann-go]'); if (b) show(i + (+b.dataset.annGo)); });
    root.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') pause(); });
    root.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') resume(); });
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget)) resume(); });
    let sx = 0, sy = 0;
    root.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; pause(); }, { passive: true });
    root.addEventListener('touchend', e => {
      const t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { paused = false; root.classList.remove('is-paused'); show(i + (dx < 0 ? 1 : -1)); }
      else resume();
    }, { passive: true });
    document.addEventListener('visibilitychange', () => (document.hidden ? pause() : resume()));
    mqM.addEventListener('change', restart);
    restart();

    /* Ordinateur : les textes se « décodent » à la première page vue de la visite */
    let seen = false;
    try { seen = sessionStorage.getItem('lslAnnDec') === '1'; sessionStorage.setItem('lslAnnDec', '1'); } catch (_) {}
    if (!seen && !mqM.matches) items.forEach((it, k) => decode(it.querySelector('.lsl-ann__t'), 250 + k * 160));
  }

  /* ================= 2. Bandeau Black Month ================= */
  function bandInit() {
    const tr = document.querySelector('.lsl-bm-band__track');
    if (!tr || tr.dataset.hd || reduce.matches) return;
    tr.dataset.hd = '1';
    const host = tr.closest('.lsl-bm-band');
    const g = document.createElement('span'); g.className = 'lsl-hd-glint'; g.setAttribute('aria-hidden', 'true'); host.append(g);
    const anim = () => tr.getAnimations && tr.getAnimations()[0];
    const a0 = anim(); if (!a0) return;
    const D = a0.effect.getTiming().duration || 35000;
    a0.currentTime = (a0.currentTime % D) + D * 400; /* marge pour pouvoir repartir en arrière */
    let rate = 1, target = 1, lastY = scrollY, lastT = 0, raf = 0, hover = false, active = 0, visible = true;
    new IntersectionObserver(es => { visible = es[0].isIntersecting; }).observe(host);
    const loop = now => {
      const a = anim(); if (!a) { raf = 0; return; }
      const y = scrollY, dt = Math.max(16, now - (lastT || now - 16)), v = (y - lastY) / dt;
      lastY = y; lastT = now;
      const base = hover ? .22 : 1;
      if (Math.abs(v) > .03) { target = Math.sign(v) * Math.min(8, base + Math.abs(v) * 7); active = now; }
      else if (now - active > 120) target = base;
      rate += (target - rate) * .09;
      a.playbackRate = rate;
      if (a.playState === 'finished') a.play();
      if (Math.abs(rate - base) < .01 && now - active > 400) { a.playbackRate = base; rate = base; raf = 0; return; }
      raf = requestAnimationFrame(loop);
    };
    const kick = () => { if (!raf && visible) { lastT = 0; lastY = scrollY; raf = requestAnimationFrame(loop); } };
    addEventListener('scroll', kick, { passive: true });
    host.addEventListener('pointerenter', () => { hover = true; kick(); });
    host.addEventListener('pointerleave', () => { hover = false; kick(); });
  }

  /* ================= 3. Header ================= */
  function headerInit() {
    const hd = document.querySelector('.shopify-section--header');
    if (!hd || hd.dataset.hd) return;
    hd.dataset.hd = '1';
    const list = hd.querySelector('.header__secondary-nav .header__icon-list');

    /* Étiquettes des icônes */
    const tip = (a, label) => { const li = a && a.closest('li'); if (li && !li.dataset.tip) { li.dataset.tip = label; li.classList.add('lsl-hd-tip'); } };
    if (list) {
      list.querySelectorAll('a').forEach(a => {
        const h = a.getAttribute('href') || '';
        if (/\/search$/.test(h)) tip(a, 'Rechercher');
        else if (/account|customer_authentication/.test(h)) tip(a, 'Compte');
        else if (/\/cart$/.test(h)) { tip(a, 'Panier'); a.classList.add('lsl-hd-cart'); }
      });
    }

    /* Icône Notice rangée dans les icônes du header */
    const nt = document.querySelector('[data-hd-notice]');
    if (nt && list && !nt.classList.contains('is-placed')) {
      const li = document.createElement('li');
      li.className = 'lsl-hd-tip lsl-hd-li-notice shrink-0'; li.dataset.tip = "Notice d'utilisation";
      nt.classList.add('tap-area', 'is-placed');
      li.append(nt);
      const ref = [...list.children].find(x => x.querySelector('a[href$="/search"]')) || list.lastElementChild;
      list.insertBefore(li, ref);
    }

    /* Panier : s'allume quand le nombre d'articles augmente */
    const cart = hd.querySelector('.lsl-hd-cart'), cc = cart && cart.querySelector('cart-count');
    if (cc) {
      const read = () => parseInt((cc.querySelector('[aria-hidden]') || cc).textContent, 10) || 0;
      let n = read();
      new MutationObserver(() => {
        const m = read();
        if (m > n && !reduce.matches) {
          cart.classList.remove('is-pop'); void cart.offsetWidth; cart.classList.add('is-pop');
          const p = document.createElement('span'); p.className = 'lsl-hd-plus'; p.setAttribute('aria-hidden', 'true'); p.textContent = '+' + (m - n);
          cart.append(p); setTimeout(() => p.remove(), 950); setTimeout(() => cart.classList.remove('is-pop'), 760);
        }
        n = m;
      }).observe(cc, { subtree: true, childList: true, characterData: true });
    }

    /* Reflet sur le logo */
    const logo = hd.querySelector('.header__logo'), img = logo && logo.querySelector('img');
    if (img && !reduce.matches && CSS.supports && CSS.supports('mask-mode', 'luminance')) {
      logo.classList.add('lsl-hd-logo');
      const sh = document.createElement('span'); sh.className = 'lsl-hd-shine'; sh.setAttribute('aria-hidden', 'true'); logo.append(sh);
      const fit = () => {
        sh.style.cssText = 'left:' + img.offsetLeft + 'px;top:' + img.offsetTop + 'px;width:' + img.offsetWidth + 'px;height:' + img.offsetHeight + 'px;--logo:url("' + (img.currentSrc || img.src) + '")';
      };
      const shine = () => { fit(); logo.classList.remove('is-shine'); void logo.offsetWidth; logo.classList.add('is-shine'); };
      if (img.complete) setTimeout(shine, 900); else img.addEventListener('load', () => setTimeout(shine, 600), { once: true });
      logo.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') shine(); });
      addEventListener('resize', fit);
    }

    /* Lumière qui suit la souris sur le haut de page (ordinateur) */
    if (fine.matches && !reduce.matches) {
      const hosts = () => [document.querySelector('.lsl-ann'), hd.querySelector('.header__wrapper'), matchMedia('(min-width: 1200px)').matches ? document.querySelector('.lsl-nv') : null].filter(Boolean);
      let hs = hosts(), bottom = 0, raf = 0, last = null, lit = false;
      const prep = () => { hs.forEach(h => h.classList.remove('lsl-hd-fx', 'is-lit')); hs = hosts(); hs.forEach(h => h.classList.add('lsl-hd-fx')); };
      prep();
      addEventListener('resize', () => { prep(); });
      const paint = () => {
        raf = 0; if (!last) return;
        const rects = hs.map(h => h.getBoundingClientRect());
        bottom = Math.max(...rects.map(r => r.bottom));
        const top = Math.min(...rects.map(r => r.top));
        const on = last.y >= top - 10 && last.y <= bottom + 30;
        if (on !== lit) { lit = on; hs.forEach(h => h.classList.toggle('is-lit', on)); }
        if (on) hs.forEach((h, k) => { h.style.setProperty('--lx', (last.x - rects[k].left) + 'px'); h.style.setProperty('--ly', (last.y - rects[k].top) + 'px'); });
      };
      addEventListener('pointermove', e => { if (e.pointerType !== 'mouse') return; last = { x: e.clientX, y: e.clientY }; if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
      html.addEventListener('mouseleave', () => { lit = false; hs.forEach(h => h.classList.remove('is-lit')); });
    }
  }

  /* ================= 4. Notice dans le tiroir du menu ================= */
  function noticeInDrawer() {
    const nt = document.querySelector('[data-hd-notice]');
    const url = nt && nt.getAttribute('href');
    if (!url) return;
    const foot = document.querySelector('.lsl-nv__foot');
    if (foot && !foot.querySelector('.lsl-hd-nvf')) {
      const a = document.createElement('a');
      a.className = 'lsl-nv__acc lsl-hd-nvf'; a.href = url;
      a.innerHTML = SV.book + "Notice d'utilisation";
      const acc = foot.querySelector('.lsl-nv__acc');
      if (acc) acc.after(a); else foot.prepend(a);
    }
    const res = document.querySelector('[data-nv-res]'), q = document.querySelector('[data-nv-q]');
    if (res && q && !res.dataset.hd) {
      res.dataset.hd = '1';
      new MutationObserver(() => {
        if (!NOTICE_RE.test(q.value) || res.querySelector('.lsl-hd-nvn') || !res.children.length) return;
        const a = document.createElement('a');
        a.className = 'lsl-nv__rall lsl-hd-nvn'; a.href = url;
        a.style.cssText = 'margin:2px 0 14px;border-color:var(--nv-ac, #9DB3D3)';
        a.innerHTML = SV.book + "Ouvrir la notice d'utilisation";
        res.prepend(a);
      }).observe(res, { childList: true });
    }
  }

  /* ================= 5. Recherche en direct ================= */
  function searchInit() {
    const sx = document.getElementById('lsl-sx');
    if (!sx || sx.dataset.ready) return;
    sx.dataset.ready = '1';
    const box = sx.querySelector('.lsl-sx__box'), q = sx.querySelector('[data-sx-q]'), body = sx.querySelector('[data-sx-res]'), st = sx.querySelector('[data-sx-st]'), form = sx.querySelector('form');
    const ideas = (sx.dataset.ideas || '').split(',').map(s => s.trim()).filter(Boolean);
    const notice = sx.dataset.notice, noticeTitle = sx.dataset.noticeTitle || "Notice d'utilisation";
    const cur = () => (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    const fmt = v => { try { return new Intl.NumberFormat(html.lang || 'fr-FR', { style: 'currency', currency: cur() }).format(parseFloat(v)); } catch (_) { return esc(v); } };
    let opener = null, tq = 0, ctrl = null, lastQ = null, act = -1;

    const recent = {
      get() { try { return JSON.parse(localStorage.getItem('lslSxRecent') || '[]').slice(0, 5); } catch (_) { return []; } },
      add(v) { v = (v || '').trim(); if (v.length < 2) return; try { const r = recent.get().filter(x => x.toLowerCase() !== v.toLowerCase()); r.unshift(v); localStorage.setItem('lslSxRecent', JSON.stringify(r.slice(0, 5))); } catch (_) {} }
    };
    const hl = (text, v) => {
      let out = esc(text);
      v.split(/\s+/).filter(w => w.length > 1).forEach(w => {
        const re = new RegExp('(' + esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        out = out.replace(re, '<mark>$1</mark>');
      });
      return out;
    };
    const featNotice = () => notice ? '<a class="lsl-sx__feat" data-opt href="' + esc(notice) + '">' + SV.book + "<span><strong>Notice d'utilisation</strong><small>" + esc(noticeTitle) + ' · tous les gestes de ton sabre, la recharge et la sécurité, version par version.</small></span></a>' : '';

    function idle() {
      const r = recent.get();
      body.innerHTML =
        (r.length ? '<p class="lsl-sx__h">Tes dernières recherches</p><div class="lsl-sx__chips">' + r.map(x => '<button type="button" class="lsl-sx__chip" data-opt data-q="' + esc(x) + '">' + SV.clock + esc(x) + '</button>').join('') + '</div>' : '') +
        (ideas.length ? '<p class="lsl-sx__h">Idées</p><div class="lsl-sx__chips">' + ideas.map(x => '<button type="button" class="lsl-sx__chip" data-opt data-q="' + esc(x) + '">' + SV.search + esc(x) + '</button>').join('') + '</div>' : '') +
        '<p class="lsl-sx__h">Raccourcis</p><div class="lsl-sx__rows">' +
        (notice ? '<a class="lsl-sx__row" data-opt href="' + esc(notice) + '">' + SV.book + "Notice d'utilisation</a>" : '') +
        '<a class="lsl-sx__row" data-opt href="' + R + 'collections/sabre-laser">' + SV.grid + 'Tous nos sabres laser</a>' +
        '<a class="lsl-sx__row" data-opt href="' + R + 'collections/sabre-laser-neopixel">' + SV.grid + 'Sabres laser NeoPixel</a></div>';
      lastQ = null; setAct(-1); st.textContent = '';
      q.setAttribute('aria-expanded', 'false');
    }

    async function search(v) {
      if (v === lastQ) return;
      lastQ = v;
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      if (!body.querySelector('.lsl-sx__prods')) body.innerHTML = '<div class="lsl-sx__grid"><div class="lsl-sx__prods">' + '<div class="lsl-sx__sk"></div>'.repeat(6) + '</div><div></div></div>';
      const u = R + 'search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product,collection,page,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      let d;
      try { d = await (await fetch(u, { signal: ctrl.signal })).json(); } catch (_) { return; }
      if (v !== lastQ) return;
      const r = (d.resources && d.resources.results) || {};
      const ps = r.products || [], cs = (r.collections || []).slice(0, 4), qs = (r.queries || []).filter(x => x.text && x.text.toLowerCase() !== v.toLowerCase()).slice(0, 4);
      let pg = (r.pages || []).slice(0, 4);
      const showNotice = notice && (NOTICE_RE.test(v) || pg.some(p => p.url && p.url.split('?')[0] === notice));
      if (showNotice) pg = pg.filter(p => !(p.url && p.url.split('?')[0] === notice));
      const all = '<a class="lsl-sx__all" data-opt href="' + R + 'search?q=' + encodeURIComponent(v) + '&amp;options%5Bprefix%5D=last" data-save>Voir tous les résultats pour « ' + esc(v) + ' » ' + SV.arrow + '</a>';
      if (!ps.length && !cs.length && !pg.length && !showNotice) {
        body.innerHTML = '<p class="lsl-sx__none">Rien trouvé pour « ' + esc(v) + ' ». Essaie un personnage, une couleur ou « NeoPixel ».</p>' +
          (ideas.length ? '<div class="lsl-sx__chips">' + ideas.map(x => '<button type="button" class="lsl-sx__chip" data-opt data-q="' + esc(x) + '">' + SV.search + esc(x) + '</button>').join('') + '</div>' : '') + all;
        st.textContent = 'Aucun résultat'; setAct(-1); return;
      }
      const card = (p, k) => {
        const price = parseFloat(p.price) > 0 ? fmt(p.price) + (parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + fmt(p.compare_at_price_max) + '</s>' : '') : '';
        return '<a class="lsl-sx__card" data-opt data-save href="' + esc(p.url) + '" style="animation-delay:' + (k * 40) + 'ms"><span class="lsl-sx__ci">' + (p.image ? '<img src="' + esc(sized(p.image, 400)) + '" alt="" loading="lazy" decoding="async">' : '') + '</span><span class="lsl-sx__ct">' + hl(p.title, v) + '</span>' + (price ? '<span class="lsl-sx__cp">' + price + '</span>' : '') + '</a>';
      };
      const row = (x, icon, k) => '<a class="lsl-sx__row" data-opt data-save href="' + esc(x.url) + '" style="animation-delay:' + (k * 40) + 'ms">' + icon + '<span>' + hl(x.title, v) + '</span></a>';
      const side =
        (qs.length ? '<div><p class="lsl-sx__h">Recherches</p><div class="lsl-sx__chips" style="margin:0">' + qs.map(x => '<button type="button" class="lsl-sx__chip" data-opt data-q="' + esc(x.text) + '">' + SV.search + hl(x.text, v) + '</button>').join('') + '</div></div>' : '') +
        (cs.length ? '<div><p class="lsl-sx__h">Collections</p><div class="lsl-sx__rows">' + cs.map((x, k) => row(x, SV.grid, k)).join('') + '</div></div>' : '') +
        (pg.length ? '<div><p class="lsl-sx__h">Pages</p><div class="lsl-sx__rows">' + pg.map((x, k) => row(x, SV.page, k)).join('') + '</div></div>' : '') + all;
      body.innerHTML = (showNotice ? featNotice() : '') + (ps.length
        ? '<div class="lsl-sx__grid"><div><p class="lsl-sx__h">Produits</p><div class="lsl-sx__prods">' + ps.map(card).join('') + '</div></div><div class="lsl-sx__side">' + side + '</div></div>'
        : '<div class="lsl-sx__side">' + side + '</div>');
      body.scrollTop = 0; setAct(-1);
      q.setAttribute('aria-expanded', 'true');
      st.textContent = ps.length + ' produit' + (ps.length > 1 ? 's' : '') + (cs.length ? ', ' + cs.length + ' collection' + (cs.length > 1 ? 's' : '') : '') + (showNotice ? ', et la notice' : '');
    }

    const opts = () => [...body.querySelectorAll('[data-opt]')];
    function setAct(n) {
      const o = opts();
      o.forEach((el, k) => { el.classList.toggle('is-act', k === n); el.id = 'lsl-sx-o' + k; el.setAttribute('role', 'option'); el.setAttribute('aria-selected', k === n ? 'true' : 'false'); });
      act = n;
      if (n >= 0 && o[n]) { q.setAttribute('aria-activedescendant', o[n].id); o[n].scrollIntoView({ block: 'nearest' }); }
      else q.removeAttribute('aria-activedescendant');
    }

    function open(from) {
      if (!sx.hidden) return;
      opener = from || document.activeElement;
      document.querySelectorAll('.lsl-nv.is-open [data-nv-close]').forEach(b => b.click());
      sx.hidden = false; html.classList.add('lsl-sx-on');
      if (!q.value.trim()) idle(); else { lastQ = null; search(q.value.trim()); }
      requestAnimationFrame(() => requestAnimationFrame(() => sx.classList.add('is-open')));
      setTimeout(() => { q.focus({ preventScroll: true }); q.select(); }, 40);
    }
    function close() {
      if (sx.hidden) return;
      sx.classList.remove('is-open'); html.classList.remove('lsl-sx-on');
      setTimeout(() => { sx.hidden = true; }, 280);
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }

    q.addEventListener('input', () => {
      const v = q.value.trim(); clearTimeout(tq);
      if (v.length < 2) { if (ctrl) ctrl.abort(); idle(); return; }
      tq = setTimeout(() => search(v), 170);
    });
    form.addEventListener('submit', () => recent.add(q.value));
    sx.addEventListener('click', e => {
      if (e.target.closest('[data-sx-close]')) { close(); return; }
      const chip = e.target.closest('[data-q]');
      if (chip) { q.value = chip.dataset.q; q.focus(); lastQ = null; search(q.value.trim()); return; }
      if (e.target.closest('[data-save]')) recent.add(q.value);
    });
    sx.addEventListener('keydown', e => {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      const o = opts();
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!o.length) return;
        e.preventDefault();
        const n = act < 0 ? (e.key === 'ArrowDown' ? 0 : o.length - 1) : (act + (e.key === 'ArrowDown' ? 1 : -1) + o.length) % o.length;
        setAct(n);
      } else if (e.key === 'Enter' && act >= 0 && o[act] && e.target === q) {
        e.preventDefault();
        if (o[act].tagName === 'A') recent.add(q.value);
        o[act].click();
      } else if (e.key === 'Tab') {
        const f = [...box.querySelectorAll('a[href], button, input:not([type="hidden"])')].filter(el => el.getClientRects().length);
        const k = f.indexOf(document.activeElement);
        if (e.shiftKey && k <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && k === f.length - 1) { e.preventDefault(); f[0].focus(); }
      }
    });

    /* La loupe du header ouvre la recherche */
    const take = () => document.querySelectorAll('.shopify-section--header a[aria-controls="search-drawer"], .shopify-section--header a[href$="/search"]').forEach(a => {
      if (a.dataset.sx) return;
      a.dataset.sx = '1'; a.setAttribute('aria-controls', 'lsl-sx'); a.setAttribute('aria-haspopup', 'dialog');
      a.addEventListener('click', e => { if (e.metaKey || e.ctrlKey || e.shiftKey) return; e.preventDefault(); e.stopPropagation(); open(a); }, true);
    });
    take();
    document.addEventListener('keydown', e => {
      const typing = e.target.closest && e.target.closest('input, textarea, select, [contenteditable="true"]');
      if ((e.key === 'k' || e.key === 'K') && (e.ctrlKey || e.metaKey)) { e.preventDefault(); sx.hidden ? open() : close(); }
      else if (e.key === '/' && !typing && sx.hidden) { e.preventDefault(); open(); }
    });
    addEventListener('pageshow', e => { if (e.persisted) { sx.classList.remove('is-open'); sx.hidden = true; html.classList.remove('lsl-sx-on'); } });
  }

  const init = () => {
    annInit(document.querySelector('[data-ann]'));
    bandInit();
    headerInit();
    noticeInDrawer();
    searchInit();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* lsl-nav.js peut arriver après : on repasse pour le tiroir */
  addEventListener('load', noticeInDrawer);
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.shopify-section--header[data-hd]').forEach(h => delete h.dataset.hd);
    init();
  });
})();
